import { colors } from '@ardoq/design-tokens';

const ArdoqShapes = () => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 130.5 80.5"
      id="state"
      data-label="State"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <ellipse rx="65" ry="40" transform="translate(65 40)" />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 130.5 80.5"
      id="decision"
      data-label="Decision"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <polygon points="0,-40 65,0 0,40 -65,0" transform="translate(65,40)" />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 130.5 80.5"
      id="item"
      data-label="Item"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <path d="M0 0h130v80H0z" />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 170.5 80.5"
      id="result"
      data-label="Result"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <path d="M40 0h130l-40 80H0z" />
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 125.5 46.5"
      id="terminal"
      data-label="Terminal"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <rect
        width="125"
        height="46"
        x="-62.5"
        y="-23"
        rx="23"
        ry="23"
        transform="translate(62.5 23)"
      ></rect>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 135.5 57.5"
      id="inputOutput"
      data-label="Input Output"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <path d="M30 0h105l-30 57H0z"></path>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 106.5 72.5"
      id="process"
      data-label="Process"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <path d="M0 0h106v72H0z"></path>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 0.75 120.5 72.5"
      id="predefinedProcess"
      data-label="Predefined Process"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <path d="M0 1h120v72H0zm12 0v72m96-72v72"></path>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 1.75 120.5 72.5"
      id="preparation"
      data-label="Preparation"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <path d="M0 38L30 2h60l30 36-30 36H30z"></path>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.25 -0.25 40.5 40.5"
      id="connection"
      data-label="Connection"
      stroke={colors.grey900}
      strokeLinecap="round"
      strokeWidth=".5"
      transform="rotate(360)"
    >
      <circle r="25" transform="translate(20 19) scale(0.75, 0.75)"></circle>
    </svg>
  </>
);

export { ArdoqShapes };

